import {
  TaggingPlanEvent,
  TaggingPlanEventAttributes,
  TaggingPlanEventCreationAttributes,
  TaggingPlanEventUpdateAttributes
} from "~/models/TaggingPlanEvent";
import { ApiClient } from '~/apiClients/ApiClient';

export default class TaggingPlanEventApiClient extends ApiClient {
  private readonly BASE_URL: string = '/api/tagging-plan-events';

  public async provideList(taggingPlanId: number) {
    const response = await this.get(`${this.BASE_URL}?taggingPlanId=${taggingPlanId}`);
    return response.data.map((attributes: TaggingPlanEventAttributes) => new TaggingPlanEvent(attributes));
  }

  public async provideById(id: number): Promise<TaggingPlanEvent> {
    const response = await this.get(`${this.BASE_URL}/${id}`);
    return new TaggingPlanEvent(response.data);
  }

  public async create(attributes: TaggingPlanEventCreationAttributes): Promise<TaggingPlanEvent> {
    const response = await this.post(this.BASE_URL, attributes);
    return new TaggingPlanEvent(response.data);
  }

  public async update(attributes: TaggingPlanEventUpdateAttributes): Promise<TaggingPlanEvent> {
    const response = await this.patch(this.BASE_URL, attributes);
    return new TaggingPlanEvent(response.data);
  }

  public async delete(id: number) {
    return super.delete(this.BASE_URL, {id});
  }
}
